import React, { useState } from 'react';
import styled from 'styled-components';

import { charts, chartsByTime, views } from '../../../constants/event';
import EventTableView from '../../table/EventTableView';
import { toRange } from '../../../converters/eventConverter';
import ChartWrapper from '../../../chart/dashboard/ChartWrapper';
import EventChart from '../../../chart/EventChart';
import LabelsChart from '../../../containers/labels/LabelsChart';

const StyleMainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .labels-chart-container {
    overflow-y: auto;
  }
`;

const StyleTableView = styled(EventTableView)`
  width: 100%;
  height: 100%;
  background-color: white !important;
  padding: 5px;
  overflow-y: auto;

  .enhanced-table {
    height: 100%;
    width: 100%;
  }
`;

const RevenuePreview = (props) => {
  const { unit, setChart, result } = props;
  const [isShowLabels, setIsShowLabels] = useState(false);

  const triggerLabels = () => {
    setIsShowLabels((prevState) => !prevState);
  };

  let { options } = props;
  options = {
    ...options,
    ...toRange(result[0].info),
  };

  return (
    <>
      {charts.includes(options.view) && (
        <StyleMainContainer>
          <ChartWrapper height={isShowLabels ? '65%' : '100%'} unit={unit} setChart={setChart}>
            <EventChart {...props} fromDashboard triggerLabels={triggerLabels} showSort />
          </ChartWrapper>
          <div className="labels-chart-container">
            {chartsByTime.includes(options.view) && isShowLabels && (
              <div className="st-labels-chart">
                <LabelsChart
                  {...props}
                  options={options}
                  from={options.from}
                  to={options.to}
                  unitId={unit.id}
                  fromDashboard
                />
              </div>
            )}
          </div>
        </StyleMainContainer>
      )}
      {options.view === views.TABLE && <StyleTableView {...props} />}
    </>
  );
};

export default RevenuePreview;
